import React, { useEffect, useState } from 'react';
import '../assets/css/about.css';
import '../assets/css/custom.css';
import bgImage from '../assets/Images/homeBackgroundImg.png';
import joinUseImg from '../assets/Images/joinUsImg.png';

import API_BASE_URL from "../../helper";
function About() {

  const [teams, setTeams] = useState([]);

    // Fetch All Team Members
    const fetchAllTeamMembers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/team/all`);
        const data = await response.json();
        setTeams(data);
      } catch (error) {
        console.error("Failed to load Team Members", error);
      }
    };

    useEffect(() => {
      fetchAllTeamMembers();
    }, []);


  return (
  <div>
    <div id="about-hero-section" className="d-flex justify-content-center align-items-center flex-column"
      style={{background: `url(${bgImage}) center/cover no-repeat`}}>
        <h2 className="text-uppercase hero-title">About Us</h2>
        <p className='hero-subheading'>You can fly high like an eagle with us..</p>
    </div>

    <section id='joinWithUs' className='mt-5'>
      <div className='container joinWithUs'>
        <div className='row textDiv'>
          <div className='text col-md-6 mb-2'>
            <div>
              <p className='fw-bold p-0 m-0 colorOne'>WEL COME EZIO INFOTECH</p>
              <h2 className='text-upercase'>Let's Joint with us</h2>
              <p className=''>At Ezio Infotech, we develop innovative and creative software and application that provide total client Satisfaction and information solutions.We belive on quality of work. <strong>Ezio Infotech Pvt Ltd</strong> is a global IT solutions company established in <strong>Jan 2022</strong>.</p>
              <p className=''>We provide improved software and web application development with completely customizable solutions to create your website. We make it our business to first completely understand your approach and vision towards your products, your customers, your business processes and then bring a comprehensive and innovative e commerce solution customized to your business requirements at inexpensive rates.</p>
              <a href='/contact' className='btn bg-primary text-white fw-bold'>Join Now</a>
            </div>
          </div>
          <div className='image col-md-6 mb-2'>
            <img className='img-fluid h-100' src={joinUseImg} alt='loading...' />
          </div>
        </div>
      </div>
    </section>

    <section id='clientProjectCounter' className='mt-5'>
      <div class="container">
        <div className='row'>
          <div className='col-md-6'>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <div class="counterTextDiv p-3 text-center"> 
                      <h2><i class="fa-solid fa-business-time"></i></h2>
                      <h4 class="fw-bold">4</h4>
                      <h4 class="fw-bold text-uppercase">Years of Experience</h4>
                    </div>
                </div>
                <div class="col-md-4 mb-2">
                    <div class="counterTextDiv p-3 text-center"> 
                      <h2><i class="fa-solid fa-users"></i></h2>
                      <h4 class="fw-bold">15</h4>
                      <h4 class="fw-bold text-uppercase">Happy Customers</h4>
                    </div>
                </div>
                <div class="col-md-4 mb-2">
                    <div class="counterTextDiv p-3 text-center"> 
                      <h2><i class="fas fa-project-diagram"></i></h2>
                      <h4 class="fw-bold">30</h4>
                      <h4 class="fw-bold text-uppercase">Total Project</h4>
                    </div>
                </div>
            </div>
          </div>
          <div className='col-md-6 mb-2'>
            <div className='row'>
              <div className='col-md-6 mb-2'>
                <div className='bg-two p-3 h-100'>
                  <h3 className='text-center text-uppercase'>Vision</h3>
                  <p>Our Mission is to achieve our goal by providing distinguished software services in the global markets by constant Innovation in Technology and our business opportunities.</p>
                </div>
              </div>
              <div className='col-md-6  mb-2'>
                <div className='bg-two p-3 h-100'>
                  <h3 className='text-center text-uppercase'>Mission</h3>
                  <p>Providing all type of effective software solutions to all kind of organization with the latest technology adopted Constant improvement and to be a leading performer in the adopted services. Making user friendly & customizable application to get the desired output. Getting the Valued customers and keep continuing serving them.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id='aboutTeam' className='mt-5'>
      <div class="container">
        <div className='row'>
          <div className='col-md-3'>
              <p className='fw-bold p-0 m-0 colorOne'>WEL COME EZIO INFOTECH</p>
              <h2 className='text-upercase'>Let's Joint with us</h2>
              <p>Our team consists of young and self-motivated domain specialists who love their work and are perfectionists. We take pride in our enthusiasm and ‘can do’ attitude which always gets work done on time.</p>
              <a href='/team' className='btn btn-primary fw-bold text-white'>View Staff</a>
          </div>
          <div className='col-md-9 mb-2'>
            <div className='row'>
              
              {teams.length > 0 ? (
              teams.slice(0, 3).map((team) => (
                <div className='col-md-4 mb-2 staffImgDiv p-3' key={team.id}>
                  <div className='p-3 h-100 position-relative' style={{
                        backgroundImage: `url(${API_BASE_URL}/assets/Images/${team.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "10px"
                      }}>
                    <div className='textDiv py-3'>
                      <h4 className='text-center staffName text-white'>{team.name}</h4>
                      <p className='text-uppercase fs-6 staffPosition text-center text-white'>{team.position}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No Team Members Available</p>
            )}



            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
  )
}

export default About;